import React from 'react';
import {
  Clock,
  Target,
  Calendar,
  FileText,
  Rocket,
  Shield,
  AlertTriangle,
  ClipboardList,
} from 'lucide-react';

const Feb24Report = () => {
  return (
    <div className="status-report">
      <div className="report-header">
        <h1 className="report-title">
          <Calendar className="w-8 h-8 text-blue-600" />
          Weekly Report — Feb 24 – Mar 2, 2026
        </h1>
        <div className="report-meta">
          <span className="meta-item">
            <Calendar className="w-4 h-4" />
            February 24 – March 2, 2026
          </span>
          <span className="meta-item">
            <Target className="w-4 h-4" />
            Approved
          </span>
          <span className="meta-item">
            <Clock className="w-4 h-4" />
            Last Week
          </span>
        </div>
      </div>

      <div className="report-grid">
        <div className="report-section">
          <h2 className="section-title">
            <FileText className="w-6 h-6 text-green-600" />
            Summary
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <p className="achievement-list">
                Word-to-PDF conversion issues, DOCX extraction (python-docx), Excel/subcontractor bulk uploads with LLM mapping, PII/privacy concerns, Kinetic demo/testing, Agent Portal POC kickoff, approval access follow-up. Key meetings: Naqi–Dhruv syncs, Agent Portal planning with Bhavya.
              </p>
            </div>
          </div>
        </div>

        <div className="report-section">
          <h2 className="section-title">
            <FileText className="w-6 h-6 text-orange-600" />
            Word-to-PDF Conversion
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Problem & Decision</h3>
                <span className="status-badge urgent">AVOID</span>
              </div>
              <ul className="achievement-list">
                <li><strong>LibreOffice (Linux):</strong> Flattens dropdowns, breaks layout</li>
                <li><strong>MS Office (Windows):</strong> Accurate results</li>
                <li><strong>Decision:</strong> Avoid PDF conversion unless last resort</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="report-section">
          <h2 className="section-title">
            <Rocket className="w-6 h-6 text-indigo-600" />
            DOCX Extraction
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <ul className="achievement-list">
                <li>Extract directly from DOCX using python-docx</li>
                <li>Note: does not preserve layout; prompt instructions may need change</li>
                <li><strong>Dhruv:</strong> Try Python-docx; discuss with Kinetic/connectivity team</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="report-section">
          <h2 className="section-title">
            <FileText className="w-6 h-6 text-blue-600" />
            Excel & Subcontractor Bulk Uploads
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <ul className="achievement-list">
                <li>Sheets: 10,000–12,000 records</li>
                <li>Workflow: LLM maps columns → Python extracts (pandas/Dask)</li>
                <li><strong>Status:</strong> Solomon sheets empty; awaiting sample data from Karan</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="report-section">
          <h2 className="section-title">
            <Shield className="w-6 h-6 text-red-600" />
            PII & Privacy
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <ul className="achievement-list">
                <li>Anonymization/scrambling before sending to LLMs</li>
                <li><strong>Dhruv:</strong> Request trainings (Rajiv, Arvind) on public vs. private info</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="report-section">
          <h2 className="section-title">
            <Rocket className="w-6 h-6 text-green-600" />
            Kinetic & Agent Portal
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Kinetic</h3>
                <span className="status-badge in-progress">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Pipeline optimization; Bhavya starting part‑1 testing</li>
                <li>Wrap: document classification scope doc not received</li>
              </ul>
            </div>
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Agent Portal POC</h3>
                <span className="status-badge scheduled">PLANNING</span>
              </div>
              <ul className="achievement-list">
                <li>Naqi, Bhavya, Bhaviya — India morning planning</li>
                <li>Work to start mid next week; Naqi to share sample emails</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="report-section">
          <h2 className="section-title">
            <ClipboardList className="w-6 h-6 text-amber-600" />
            Action Items
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <ul className="achievement-list">
                <li><strong>Dhruv:</strong> Python-docx, Kinetic approach, map fields, PII trainings, table detection</li>
                <li><strong>Bhavya:</strong> Pipeline optimization for part‑1 testing</li>
                <li><strong>Naqi:</strong> Use cases, sample emails</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="report-section">
          <h2 className="section-title">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
            Risks & Dependencies
          </h2>
          <div className="achievement-cards">
            <div className="achievement-card">
              <ul className="achievement-list">
                <li>Kinetic: Solomon sheets empty; delivery depends on sample data</li>
                <li>DOCX: prompt instructions may need adjustment</li>
              </ul>
            </div>
          </div>
        </div>

      </div>

      <div className="report-footer">
        <p><strong>Report Date:</strong> February 24 – March 2, 2026</p>
        <p><strong>Source:</strong> ai-bimonthly/feb-24-26/weekly-report.md</p>
      </div>
    </div>
  );
};

export default Feb24Report;
